const clientSpecificAccess = () => {
  //TODO: change with original session
  // const { clientName } = fetchSession();
  // return (clientName === 'KSEB');
  return false;
};

export const getSLDImageAndAltForSinglePoint = (
  className,
  diCurrentStatus,
  orientation,
  category,
  originalAltText,
  originalImg
) => {
  let img, alt;
  switch (
    className +
    '_' +
    diCurrentStatus +
    '_' +
    orientation +
    '_' +
    category
  ) {
    // Isolators Single Point
    case 'isolator_0_vertical_undefined': // backward compatibility for category addition
    case 'isolator_0_vertical_isolator':
      img = '/Images/IEEE1975/Feeder_Coupler_open_IEE75.png';
      alt = 'feederCouplerOpen';
      break;

    case 'isolator_0_horizontal_undefined':
    case 'isolator_0_horizontal_isolator':
      img = '/Images/IEEE1975/Bus_Coupler_open_IEE75.png';
      alt = 'busCouplerOpen';
      break;

    case 'isolator_1_vertical_undefined':
    case 'isolator_1_vertical_isolator':
      img = '/Images/IEEE1975/Feeder_Coupler_close_IEE75.png';
      alt = 'feederCouplerClose';
      break;

    case 'isolator_1_horizontal_undefined':
    case 'isolator_1_horizontal_isolator':
      img = '/Images/IEEE1975/Bus_Coupler_close_IEE75.png';
      alt = 'busCouplerClose';
      break;

    // Single Point Circuit Breakers
    case 'breaker_0_vertical_undefined':
    case 'breaker_0_vertical_isolator':
      img = '/Images/IEEE1975/Circuit_Breaker_Open_IEE75.png';
      alt = 'circuitBreakerOpen';
      break;

    case 'breaker_0_horizontal_undefined':
    case 'breaker_0_horizontal_isolator':
      img = '/Images/IEEE1975/Circuit_Breaker_Open_1_IEE75.png';
      alt = 'circuitBreakerOpenHorizontal';
      break;

    case 'breaker_1_vertical_undefined':
    case 'breaker_1_vertical_isolator':
      img = '/Images/IEEE1975/Circuit_Breaker_Closed_IEE75.png';
      alt = 'circuitBreakerClosed';
      break;

    case 'breaker_1_horizontal_undefined':
    case 'breaker_1_horizontal_isolator':
      img = '/Images/IEEE1975/Circuit_Breaker_Closed_1_IEE75.png';
      alt = 'circuitBreakerClosedHorizontal';
      break;

    // Relay
    case 'relay_0_NA_undefined':
    case 'relay_0_NA_relay':
      img = clientSpecificAccess()
        ? '/Images/IEEE1975/relayOp_Inactive_IEE75_KSEB.png'
        : '/Images/IEEE1975/relayOp_Inactive_IEE75.png';
      alt = 'relayOp_Inactive';
      break;

    case 'relay_1_NA_undefined':
    case 'relay_1_NA_relay':
      img = '/Images/IEEE1975/relayOp_Active_IEE75.png';
      alt = 'relayOp_Active';
      break;

    // Single Point Earth Switches open
    case 'isolator_0_vertical_earthSwitchTop':
      img = '/Images/IEEE1975/earth_switch_top_open.png';
      alt = 'earthSwitchTopOpen';
      break;

    case 'isolator_0_vertical_earthSwitchDown':
      img = '/Images/IEEE1975/earth_switch_down_open.png';
      alt = 'earthSwitchDownOpen';
      break;

    case 'isolator_0_horizontal_earthSwitchLeft':
      img = '/Images/IEEE1975/earth_switch_left_open.png';
      alt = 'earthSwitchLeftOpen';
      break;

    case 'isolator_0_horizontal_earthSwitchRight':
      img = '/Images/IEEE1975/earth_switch_right_open.png';
      alt = 'earthSwitchRightOpen';
      break;

    // Single Point Earth Switches close
    case 'isolator_1_vertical_earthSwitchTop':
      img = '/Images/IEEE1975/earth_switch_top_close.png';
      alt = 'earthSwitchTopClose';
      break;

    case 'isolator_1_vertical_earthSwitchDown':
      img = '/Images/IEEE1975/earth_switch_down_close.png';
      alt = 'earthSwitchDownClose';
      break;

    case 'isolator_1_horizontal_earthSwitchLeft':
      img = '/Images/IEEE1975/earth_switch_left_close.png';
      alt = 'earthSwitchLeftClose';
      break;

    case 'isolator_1_horizontal_earthSwitchRight':
      img = '/Images/IEEE1975/earth_switch_right_close.png';
      alt = 'earthSwitchRightClose';
      break;

    // No Category - no change in image
    default:
      img = originalImg;
      alt = originalAltText;
      break;
  }
  return { img, alt };
};
